"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = exports.ORIGIN_GROUP_WIDGET = exports.ORIGIN_GROUP_OVERVIEW = exports.GroupItem = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _Members = _interopRequireDefault(require("@insided/destination/icons/Members"));

var _LockClosed = _interopRequireDefault(require("@insided/destination/icons/LockClosed"));

var _EyeCross = _interopRequireDefault(require("@insided/destination/icons/EyeCross"));

var _Conversation = _interopRequireDefault(require("@insided/destination/icons/Conversation"));

var _Checkmark = _interopRequireDefault(require("@insided/shared/icons/Checkmark"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _zod = require("zod");

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _axios = _interopRequireDefault(require("axios"));

var _csrfToken = require("../utils/csrfToken");

var _message = _interopRequireDefault(require("../design-system-components/message"));

var _mixpanelEventsFromDestination = require("../utils/mixpanelEventsFromDestination");

var _globals = require("@insided/shared/utils/globals");

var _userContext = require("../../server-middleware/userContext");

var _GroupTags = require("./GroupTags");

var _classnames = _interopRequireDefault(require("classnames"));

var _widgetContainer = require("@insided/deprecated-preact-components/widget-container");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ORIGIN_GROUP_OVERVIEW = 'JoinViaGroupOverview';
exports.ORIGIN_GROUP_OVERVIEW = ORIGIN_GROUP_OVERVIEW;
var ORIGIN_GROUP_WIDGET = 'JoinViaGroupWidget';
exports.ORIGIN_GROUP_WIDGET = ORIGIN_GROUP_WIDGET;
var PUBLIC_GROUP_TYPE = 4;
var PRIVATE_GROUP_TYPE = 5;
var HIDDEN_GROUP_TYPE = 6;
var widgetName = 'group_overview';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-group_overview';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.undefined();

exports.config = config;

var GroupUsersTypeMeta = function GroupUsersTypeMeta(group) {
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: (0, _classnames.default)('group-overview-item__meta', 'group-overview-item__meta--members-total', 'text--meta')
  }, group.type === PUBLIC_GROUP_TYPE ? (0, _preact.h)("div", {
    style: {
      display: 'flex'
    }
  }, (0, _preact.h)(_Members.default, {
    width: 20,
    height: 20
  }), ' ', (0, _preact.h)("span", {
    className: "group-overview-item__meta-text"
  }, group.totalMembers, " ", (0, _preact.h)(_phrase.default, {
    p: "Members"
  }))) : null, group.type === PRIVATE_GROUP_TYPE ? (0, _preact.h)("div", {
    style: {
      display: 'flex'
    }
  }, (0, _preact.h)(_LockClosed.default, {
    width: 20,
    height: 20
  }), (0, _preact.h)("span", {
    className: "group-overview-item__meta-text"
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.private.group"
  }))) : null, group.type === HIDDEN_GROUP_TYPE ? (0, _preact.h)("div", {
    style: {
      display: 'flex'
    }
  }, (0, _preact.h)(_EyeCross.default, {
    width: 20,
    height: 20
  }), (0, _preact.h)("span", {
    className: "group-overview-item__meta-text"
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.hidden.group"
  }))) : null), (0, _preact.h)("div", {
    className: (0, _classnames.default)('group-overview-item__meta', 'group-overview-item__meta--topics-total', 'text--meta')
  }, (0, _preact.h)(_Conversation.default, {
    width: 20,
    height: 20
  }), ' ', (0, _preact.h)("span", {
    className: "group-overview-item__meta-text"
  }, group.totalTopics === 0 ? (0, _preact.h)(_phrase.default, {
    p: "groups.no.topics.yet"
  }) : (0, _preact.h)("span", null, group.totalTopics, " ", (0, _preact.h)(_phrase.default, {
    p: "Topic|Topics",
    count: {
      n: group.totalTopics.toString()
    }
  })))));
};

var GroupMembershipButton = function GroupMembershipButton(props) {
  if (!props.membershipStatus) {
    return null;
  }

  if (props.membershipStatus === 'requested') {
    return (0, _preact.h)(_Button.default, {
      key: "no-action-button",
      medium: true,
      className: "no-hover",
      secondary: true,
      type: "button"
    }, (0, _preact.h)(_phrase.default, {
      p: "groups.request.join.group"
    }));
  }

  if (props.membershipStatus === 'not_member') {
    return (0, _preact.h)(_Button.default, {
      key: "action-button",
      loading: props.isLoading,
      medium: true,
      primary: true,
      type: "button",
      onClick: function onClick(e) {
        props.onJoin();
        e.stopPropagation();
        e.preventDefault();
      }
    }, (0, _preact.h)(_phrase.default, {
      p: props.groupType === PUBLIC_GROUP_TYPE ? 'groups.join.group' : 'groups.request.to.join'
    }));
  } // props.membershipStatus === 'joined' || props.membershipStatus === 'group_admin'


  return (0, _preact.h)(_Button.default, {
    key: "joined-button",
    medium: true,
    className: "no-hover",
    secondary: true,
    type: "button"
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.you.are.member"
  }));
};

var GroupItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupItem, _Component);

  var _super = _createSuper(GroupItem);

  function GroupItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GroupItem);
    _this = _super.call(this, props);
    _this.state = {
      isLoading: false,
      membershipStatus: props.membershipStatus
    };
    _this.joinGroup = _this.joinGroup.bind((0, _assertThisInitialized2.default)(_this));
    _this.getGroupType = _this.getGroupType.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(GroupItem, [{
    key: "joinGroup",
    value: function () {
      var _joinGroup = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var event, _yield$Axios$post, data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (window.inSidedData.user.userid) {
                  _context.next = 4;
                  break;
                }

                event = new window.CustomEvent('GuestUserAction');
                window.dispatchEvent(event);
                return _context.abrupt("return");

              case 4:
                this.setState({
                  isLoading: true
                });
                _context.prev = 5;
                _context.next = 8;
                return _axios.default.post("/group/".concat(this.props.id, "/join?joinOrigin=").concat(this.props.origin), {
                  csrfToken: (0, _csrfToken.csrfToken)()
                });

              case 8:
                _yield$Axios$post = _context.sent;
                data = _yield$Axios$post.data;
                this.setState({
                  isLoading: false
                });

                if (typeof this.props.onMembershipStatusChanged === 'function') {
                  this.props.onMembershipStatusChanged(data.membershipStatus);
                  this.setState({
                    membershipStatus: data.membershipStatus
                  });
                }

                if (this.props.type === PRIVATE_GROUP_TYPE) {
                  (0, _mixpanelEventsFromDestination.trackRequestToJoinPrivateGroup)(window.inSidedData.page.url === '/groups' ? 'RequestViaGroupOverview' : 'RequestViaGroupWidget', Number(this.props.id));
                }

                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);
                this.setState({
                  isLoading: false
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 15]]);
      }));

      function joinGroup() {
        return _joinGroup.apply(this, arguments);
      }

      return joinGroup;
    }()
  }, {
    key: "getGroupType",
    value: function getGroupType() {
      if (this.props.type === PRIVATE_GROUP_TYPE) {
        return 'private';
      }

      if (this.props.type === HIDDEN_GROUP_TYPE) {
        return 'hidden';
      }

      return 'public';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var group = this.props;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          membershipStatus = _this$state.membershipStatus;
      var GroupItemTitleTag = (0, _widgetContainer.genericWidgetHeaderTagCalculator)(this.props.hasWidgetTitle, this.props.hasWidgetSubtitle);
      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        return (0, _preact.h)(_userContext.CurrentUserContext.Consumer, null, function (user) {
          return (0, _preact.h)("a", {
            className: "group-overview-item card-widget-wrapper ".concat(group.isEvenCount ? 'group-overview-item--even' : ''),
            href: (0, _absoluteUrlRuntime.resolveUrl)(group.url)
          }, (0, _preact.h)(_LazyImage.default, {
            type: "background",
            src: (0, _absoluteUrlRuntime.resolveUrl)(group.thumbnail),
            className: "group-overview-item__top"
          }, !modules.includes('NewUICardGroupOverview') && group.type === PUBLIC_GROUP_TYPE ? (0, _preact.h)("div", {
            className: "group-overview-item__top-content"
          }, group.recentMembers.concat([]).reverse().map(function (member) {
            if (member.id === user.id) {
              return null;
            }

            return (0, _preact.h)("div", {
              key: member.id,
              className: "group-overview-item__member"
            }, (0, _preact.h)("span", {
              className: "group-overview-item__member-link"
            }, (0, _preact.h)(_UserAvatar.default, {
              user: member,
              extraClass: "avatar avatar--S",
              showRank: true
            })));
          }), group.isUserMember ? (0, _preact.h)("div", {
            key: "me",
            className: "group-overview-item__member"
          }, (0, _preact.h)("span", {
            className: "group-overview-item__member-link"
          }, (0, _preact.h)(_Checkmark.default, {
            height: 30,
            width: 30
          }))) : null) : null), (0, _preact.h)("div", {
            className: "group-overview-item__bottom ".concat(group.showGroupMeta ? '' : 'group-overview-item__bottom--without-meta')
          }, (0, _preact.h)(GroupItemTitleTag, {
            className: "h4 card-widget-title"
          }, group.title), !modules.includes('NewUICardGroupOverview') ? (0, _preact.h)(GroupUsersTypeMeta, group) : null, modules.includes('NewUICardGroupOverview') && group.showGroupMeta ? (0, _preact.h)("div", {
            className: (0, _classnames.default)('group-overview-item__meta', 'group-overview-item__meta--members-total', 'text--meta')
          }, (0, _preact.h)("div", {
            style: {
              display: 'flex'
            }
          }, (0, _preact.h)("span", {
            style: {
              color: '#6B707E'
            }
          }, (0, _preact.h)(_phrase.default, {
            p: "groups.".concat(_this2.getGroupType(), ".group")
          }), " \u2022 ", group.totalMembers, ' ', (0, _preact.h)(_phrase.default, {
            p: "Members"
          })))) : null, modules.includes('NewUICardGroupOverview') && (!group.isUserMember || group.displayUserStatus) ? (0, _preact.h)("div", {
            className: "join-group-btn-wrapper"
          }, (0, _preact.h)(GroupMembershipButton, {
            membershipStatus: membershipStatus,
            isLoading: isLoading // eslint-disable-next-line @typescript-eslint/unbound-method
            ,
            onJoin: _this2.joinGroup,
            groupType: group.type
          })) : null));
        });
      });
    }
  }]);
  return GroupItem;
}(_preact.Component);

exports.GroupItem = GroupItem;

var GroupsOverview = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(GroupsOverview, _Component2);

  var _super2 = _createSuper(GroupsOverview);

  function GroupsOverview(props) {
    var _this3;

    (0, _classCallCheck2.default)(this, GroupsOverview);
    _this3 = _super2.call(this, props);
    var tagCount = {};
    props.groups.otherGroups.forEach(function (group) {
      group.tags.forEach(function (tag) {
        if (tagCount[tag]) {
          tagCount[tag]++;
        } else {
          tagCount[tag] = 1;
        }
      });
    });
    _this3.state = {
      selectedTags: [],
      tagCount: tagCount,
      successMessageFor: null,
      joinedGroupTitle: ''
    };
    _this3.selectTag = _this3.selectTag.bind((0, _assertThisInitialized2.default)(_this3));
    return _this3;
  }

  (0, _createClass2.default)(GroupsOverview, [{
    key: "selectTag",
    value: function selectTag(item) {
      if (this.state.selectedTags.includes(item)) {
        this.setState({
          selectedTags: this.state.selectedTags.filter(function (tag) {
            return tag !== item;
          })
        });
      } else {
        this.setState({
          selectedTags: [].concat((0, _toConsumableArray2.default)(this.state.selectedTags), [item])
        });
      }

      _publish.default.trackEvent('userevent', {
        event_source: 'control',
        // mixpanel-forwarder is ignoring any other type of event
        type: 'Group overview tag clicked',
        name: item
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state2 = this.state,
          selectedTags = _this$state2.selectedTags,
          successMessageFor = _this$state2.successMessageFor,
          joinedGroupTitle = _this$state2.joinedGroupTitle;
      var _this$props = this.props,
          groups = _this$props.groups,
          hasWidgetTitle = _this$props.hasWidgetTitle,
          hasWidgetSubtitle = _this$props.hasWidgetSubtitle;
      var myGroups = groups.myGroups,
          otherGroups = groups.otherGroups;
      var allGroupTags = otherGroups.reduce(function (acc, group) {
        group.tags.forEach(function (tag) {
          if (!acc.includes(tag)) {
            acc.push(tag);
          }
        });
        return acc;
      }, []);
      var filteredGroups = otherGroups.filter(function (group) {
        if (!selectedTags.length) return true;
        return selectedTags.some(function (tag) {
          return group.tags.includes(tag);
        });
      });
      return (0, _preact.h)("div", {
        className: "sitewidth"
      }, (0, _preact.h)("div", {
        className: "group-overview-wrapper"
      }, successMessageFor !== null ? (0, _preact.h)(_message.default, {
        variant: "success",
        onDismiss: function onDismiss() {
          return _this4.setState({
            successMessageFor: null
          });
        },
        timer: 5000
      }, (0, _preact.h)(_phrase.default, {
        p: successMessageFor === 'joined' ? 'group.joined.successfully' : 'group.join.request.is.sent',
        count: {
          g: joinedGroupTitle
        }
      })) : null, (0, _preact.h)("div", {
        className: "sitewidth text-center"
      }, (0, _preact.h)("h1", {
        className: "group-overview-wrapper-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups"
      }))), myGroups.length ? (0, _preact.h)("div", {
        className: "groups--mine"
      }, (0, _preact.h)("h2", {
        className: "h4 group-overview-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.my.groups"
      })), (0, _preact.h)("div", {
        className: "group-overview"
      }, myGroups.map(function (group) {
        return (0, _preact.h)(GroupItem, (0, _extends2.default)({
          hasWidgetTitle: true,
          hasWidgetSubtitle: false,
          key: group.id,
          isEvenCount: myGroups.length === 2 || myGroups.length === 4,
          isUserMember: true
        }, group, {
          showGroupMeta: false
        }));
      }))) : null, otherGroups.length ? (0, _preact.h)("div", {
        className: "groups--other"
      }, (0, _preact.h)("h2", {
        className: "h4 group-overview-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.find.new.group"
      })), (0, _preact.h)(_GroupTags.GroupTags, {
        tags: allGroupTags,
        selectedTags: selectedTags,
        onTagClick: function onTagClick(tagLabel) {
          return _this4.selectTag(tagLabel);
        }
      }), (0, _preact.h)("div", {
        className: "group-overview"
      }, filteredGroups.map(function (group) {
        return (0, _preact.h)(GroupItem, (0, _extends2.default)({
          key: group.id,
          onMembershipStatusChanged: function onMembershipStatusChanged(newMembershipStatus) {
            return _this4.setState({
              successMessageFor: newMembershipStatus,
              joinedGroupTitle: group.title
            });
          },
          hasWidgetTitle: hasWidgetTitle,
          hasWidgetSubtitle: hasWidgetSubtitle,
          isEvenCount: filteredGroups.length === 2 || filteredGroups.length === 4,
          origin: ORIGIN_GROUP_OVERVIEW
        }, group, {
          showGroupMeta: true
        }));
      }))) : null));
    }
  }]);
  return GroupsOverview;
}(_preact.Component);

var _default = GroupsOverview;
exports.default = _default;